export default __webpack_public_path__ + "static/media/man3.3ef9cfcf.jpg";